module.exports = __webpack_public_path__ + "h5/img/bojin_1.4f6fd93a.png";